<template>
  <a-modal
    :visible.sync="TipDialogVisible"
    width="640px"
    class="new-dialog-box"
    :mask-closable="false"
    :footer="null"
    :centered="true"
    @cancel="TipDialogVisible=false"
  >
    <div
      class="new-dialog-tip-box"
    >
      <div class="new-f-top-banner" />
      <div class="new-f-top-con">
        <div
          class="new-feature-con"
          v-html="newFeatureInfo"
        />
        <a-button
          type="primary"
          @click="TipDialogVisible=false"
        >
          {{ $t('message["1276"]') }}
        </a-button>
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
  },
  data () {
    return {
      TipDialogVisible: false,
      submiting: false
    }
  },
  computed: {
    ...mapState('newFeature', ['newFeatureInfo'])
  },
  mounted () {
  },
  methods: {
    changeLimitDialog (b) {
      this.TipDialogVisible = b
    }
  }
}
</script>
<style lang="scss" scoped>
.new-dialog-tip-box {
  .new-f-top-banner {
    background: url(../../assets/images/img-new.png) no-repeat 0 0;
    background-size: 640px 80px;
    width: 640px;
    height: 80px;
  }
  .new-f-top-con {
    padding: 24px 5px 40px 40px;
  }
  .new-feature-con {
    margin-bottom: 24px;
    max-height: 280px;
    overflow-y: auto;
    padding-right: 16px;
  }
}
</style>
<style lang="scss">
  .new-dialog-box {
    .ant-modal-body {
      padding: 0;
    }
    .ant-modal-close {
      // display: none;
    }
  }
</style>
